"use client";

import { create } from "zustand";

type NoEnergyModalState = {
  open: boolean;
  show: () => void;
  hide: () => void;
};

/**
 * Lightweight global state for the "Out of energy" full-screen gate.
 * Triggered by any play entry point (home, bottom nav, friends list) when
 * the player has < ENERGY_COST_PER_MATCH energy.
 */
export const useNoEnergyModal = create<NoEnergyModalState>((set) => ({
  open: false,
  show: () => set({ open: true }),
  hide: () => set({ open: false }),
}));
